import { render, staticRenderFns } from "./AddSubscriptionComponent.vue?vue&type=template&id=3c4d56fc"
import script from "./AddSubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./AddSubscriptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports